export const GET_UNREAD_NOTIFICATIONS_STATUS = "GET_UNREAD_NOTIFICATIONS_STATUS";
export const RESET_UNREAD_NOTIFICATIONS = "RESET_UNREAD_NOTIFICATIONS";
export const START_LOADING_UNREAD_NOTIFICATIONS = "START_LOADING_UNREAD_NOTIFICATIONS";
export const STOP_LOADING_UNREAD_NOTIFICATIONS = "STOP_LOADING_UNREAD_NOTIFICATIONS";
export const ERROR_LOADING_UNREAD_NOTIFICATIONS = "ERROR_LOADING_UNREAD_NOTIFICATIONS";